import { MockFactory } from '@tino-frontend/mocks'
import { CheckUnicoResponse } from '@types'

export const checkUnicoResponseMock = new MockFactory<CheckUnicoResponse>({
  workflow_id: 'workflow_id_1',
  run_id: 'run_id_1',
})
